import { FormattedMessage } from "react-intl";

import { ContractFeatures, TokenMetadata, TokenRarity, type IToken } from "@framework/types";
import { Card, Typography } from "@dzambalaorg/ui-kit";

import { StyledToolbar } from "./styled";

export interface IRarityTokenPanelProps {
  token: IToken;
}

export const RarityTokenPanel = (props: IRarityTokenPanelProps) => {
  const { token } = props;

  if (!token.template?.contract?.contractFeatures.includes(ContractFeatures.RANDOM)) {
    return null;
  }

  return (
    <Card>
      <Card.Content>
        <StyledToolbar disableGutters>
          <Typography variant="h5" component="p">
            <FormattedMessage id="pages.token.rarity" />
          </Typography>
        </StyledToolbar>
        <Typography>{Object.values(TokenRarity)[token.metadata[TokenMetadata.RARITY]]}</Typography>
      </Card.Content>
    </Card>
  );
};
